import styled from 'styled-components';

export const StyledWrapper = styled.div`
    display: flex;
    gap: 25px;

    .dropdown {
      width: 100%;
      flex-grow: 1 0 auto;
    }
`